import { Col, Row } from "antd";
import React from "react";
import file from "src/shared/assets/images/landing/file-text-f.png";
import shield from "src/shared/assets/images/landing/shield-f.png";
import lock from "src/shared/assets/images/landing/lock-f.png";
import "./feature.less";

const LFeature2 = () => {
  return (
    <section id="feature" className="bg-second">
      <Row justify="center">
        <Col xs={23} lg={21}>
          <Row justify="space-between" gutter={[15, 15]}>
            <Col xs={24} lg={7}>
              <img src={file} />
              <h4>کاملا سازگار با قوانین اینستاگرام</h4>
              <p>
                نقض هر یک از موارد بالا، نقض قوانین اینستاگرام است و فرد باید
                برای پایدار بودن در این شبکه اجتماعی، موارد فوق را رعایت کند
              </p>
            </Col>
            <Col xs={24} lg={7}>
              <img src={shield} />
              <h4>کاملا امن و مطمئن برای پیج شما</h4>
              <p>
                نقض هر یک از موارد بالا، نقض قوانین اینستاگرام است و فرد باید
                برای پایدار بودن در این شبکه اجتماعی، موارد فوق را رعایت کند
              </p>
            </Col>
            <Col xs={24} lg={7}>
              <img src={lock} />
              <h4>بدون نیاز به پسورد پیج شما</h4>
              <p>
                نقض هر یک از موارد بالا، نقض قوانین اینستاگرام است و فرد باید
                برای پایدار بودن در این شبکه اجتماعی، موارد فوق را رعایت کند
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default LFeature2;
